<p class="help_title">
	<a 
		[href]="openGuide()" 
		appTooltip="Guida utente" 
		placement="bottom" 
		[appTooltipEnabled]="true" 
		target="_blank" 
		aria-label="Consulta la guida utente">
			<span class="glyphicon glyphicon-question-sign"></span>
	</a>
</p>

